<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/australia/mclaren-valley')"></nuxt-link> Producers</div>
                    <nuxt-link class="wine-guide-country active" :to="localePath('/wine-guide/australia/mclaren-valley/fox-creek')">Fox Creek</nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/australia/barrossa-valley')"></nuxt-link> Producers</div>
                    <v-select
                            :items="items"
                            v-model="select"
                            label="Please choose"
                            single-line
                            item-text="report"
                            item-value="src"
                            return-object
                            class="show-mobile"
                            v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Fox Creek</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Se ami viaggiare e ami il vino australiano, allora sei nel posto giusto. Perché gli eccellenti vini Shiraz di Fox Creek ti portano nel sud dell'Australia in un solo sorso.
                    </div>

                    <div class="howto-title2">Tenerlo in famiglia</div>
                    <div class="howto-text">
                        Una cantina relativamente recente (ma un veterano per l'industria vinicola australiana), Fox Creek è stata fondata nel 1984 da Jim e Helen Watts a McClaren Vale. Inizialmente hobbisti, Jim ed Helen hanno passato anni a sviluppare i terreni di argilla nera della loro tenuta di 32 ettari, vendendo la frutta ai viticoltori vicini. Tuttavia, una figlia laureata in enologia ha cambiato tutto; la prima annata della tenuta, uno Shiraz del 1994 (ora praticamente introvabile) è stato un successo immediato e ha portato Fox Creek in cima alla lista dei vini pregiati. Il resto è storia della vinificazione.
                    </div>

                    <div class="howto-title2">Pizzazz nello Shiraz</div>
                    <div class="howto-text">
                        Il nome Fox Creek è sinonimo di Shiraz. La Riserva proviene da vari blocchi di vigneti di alta qualità piantati in terroir di terriccio grigio e ghiaia rossa. Le uve vengono fermentate sulle bucce per un massimo di 10 giorni, prima di essere fermentate in vasche di acciaio inossidabile nella loro cantina all'avanguardia. Mentre la Riserva è chiaramente il loro vino di punta (e il punteggio più alto - Robert Parker ha assegnato il 96/100 del 1998), anche Fox Creek ha avuto un grande successo con le loro miscele, che includono Cabernet Sauvignon, Cabernet Franc, Merlot, Chardonnay, Sauvignon Blanc e Verdelho. Fox Creek fornisce uve coltivate solo nella McLaren Vale, la maggior parte delle quali proviene dai propri vigneti di proprietà.
                    </div>

                    <div class="howto-title2">I mercati emergenti significano mercati di esportazione</div>
                    <div class="howto-text">
                        È interessante notare che il loro sito Web è in cinese oltre che in inglese, il che implica che le vendite a est sono buone e sembrano destinate a rimanere tali. La Cina è il più grande importatore di vini australiani (seguita da Svezia, Cina, Tailandia, Russia e Singapore), un fatto senza dubbio aiutato dal "Export and Regional Wine Support Package" del governo australiano, uno stanziamento una tantum di $ 50 milioni di AUD (€ 30 milioni), per incoraggiare la crescita del settore attraverso sia le esportazioni che il turismo regionale.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Fox Creek</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Wenn Sie gerne reisen und australischen Wein lieben, dann sind Sie bei uns genau richtig. Denn die hervorragenden Shiraz-Weine von Fox Creek entführen Sie in einem einzigen Schluck in den Süden Australiens.
                    </div>

                    <div class="howto-title2">Es bleibt in der Familie</div>
                    <div class="howto-text">
                        Fox Creek ist ein relativ neues Weingut (noch ein Oldtimer für die australische Weinindustrie) und wurde 1984 von Jim und Helen Watts in McClaren Vale gegründet. Jim und Helen waren zunächst Hobbybauern und verbrachten Jahre damit, die schwarzen Lehmböden ihres 32 Hektar großen Anwesens zu erschließen und die Früchte an benachbarte Winzer zu verkaufen. Doch eine Tochter, die ihr Önologiestudium abschloss, änderte alles; Der erste Jahrgang des Weinguts, ein (heute praktisch nicht mehr zu findender) Shiraz aus dem Jahr 1994, war ein sofortiger Erfolg und brachte Fox Creek an die Spitze der Spitzenklasse der Weine. Der Rest ist Weinbaugeschichte.
                    </div>

                    <div class="howto-title2">Pizza im Shiraz</div>
                    <div class="howto-text">
                        Der Name Fox Creek ist gleichbedeutend mit Shiraz. Das Reservat stammt aus verschiedenen hochwertigen Weinbergblöcken, die im Terroir aus grauem Lehm und rotem Kies gepflanzt sind. Die Trauben werden bis zu 10 Tage lang auf der Schale vergoren, bevor sie in ihrem hochmodernen Weingut in Edelstahltanks vergoren werden. Während der Reserve eindeutig ihr Flaggschiffwein ist (und die höchste Bewertung – Robert Parker vergab 1998 96/100), hatte Fox Creek auch großen Erfolg mit seinen Mischungen, zu denen Cabernet Sauvignon, Cabernet Franc, Merlot, Chardonnay, Sauvignon Blanc und Verdelho gehören. Fox Creek bezieht ausschließlich im McLaren Vale angebaute Trauben, von denen die meisten von den eigenen Weinbergen stammen.
                    </div>

                    <div class="howto-title2">Schwellenmärkte bedeuten Exportmärkte</div>
                    <div class="howto-text">
                        Es ist interessant festzustellen, dass ihre Website sowohl auf Chinesisch als auch auf Englisch ist, was darauf hindeutet, dass die Verkäufe im Osten gut sind und dies voraussichtlich auch bleiben werden. China ist der größte Importeur australischer Weine (gefolgt von Schweden, China, Thailand, Russland und Singapur), eine Tatsache, die zweifellos durch das „Export and Regional Wine Support Package“ der australischen Regierung unterstützt wird, eine einmalige Zuweisung von 50 Millionen AUD (30 Millionen Euro), um das Wachstum der Branche sowohl durch Exporte als auch durch regionalen Tourismus zu fördern.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Fox Creek</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Si vous aimez les voyages et que vous aimez le vin australien, alors vous êtes au bon endroit. Parce que les excellents vins de Shiraz de Fox Creek vous emmènent dans le sud de l'Australie en une seule gorgée.
                    </div>

                    <div class="howto-title2">Le garder dans la famille</div>
                    <div class="howto-text">
                        Domaine viticole relativement récent (mais ancien pour l'industrie viticole australienne), Fox Creek a été créé en 1984 par Jim et Helen Watts à McClaren Vale. Amateurs au début, Jim et Helen ont passé des années à développer les sols d'argile noire de leur domaine de 32 hectares, vendant les fruits aux vignerons voisins. Cependant, une fille diplômée en œnologie a changé tout cela; le premier millésime du domaine, un Shiraz 1994 (maintenant pratiquement introuvable) a été un succès instantané et a propulsé Fox Creek au sommet de la pile de vins fins. Le reste est l'histoire de la vinification.
                    </div>

                    <div class="howto-title2">Pizzazz dans le Shiraz</div>
                    <div class="howto-text">
                        Le nom Fox Creek est synonyme de Shiraz. La Réserve est issue de différentes parcelles de vignes de grande qualité plantées sur un terroir de limons gris et de graves rouges. Les raisins sont fermentés sur leur peau jusqu'à 10 jours, avant d'être fermentés dans des cuves en acier inoxydable dans leur cave ultramoderne. Alors que la réserve est clairement leur vin phare (et la note la plus élevée - Robert Parker a donné le 1998 96/100), Fox Creek a également eu un grand succès avec ses assemblages, qui comprennent le cabernet sauvignon, le cabernet franc, le merlot, le chardonnay, le sauvignon blanc et le verdelho. Fox Creek s'approvisionne en raisins cultivés uniquement dans la McLaren Vale, dont la plupart proviennent de ses propres vignobles.
                    </div>

                    <div class="howto-title2">Les marchés émergents sont synonymes de marchés d'exportation</div>
                    <div class="howto-text">
                        Il est intéressant de noter que leur site Web est en chinois et en anglais, ce qui implique que les ventes à l'Est sont bonnes et qu'elles devraient le rester. La Chine est le plus grand importateur de vins australiens (suivie de la Suède, de la Chine, de la Thaïlande, de la Russie et de Singapour), un fait sans aucun doute aidé par le "Export and Regional Wine Support Package" du gouvernement australien, une allocation unique de 50 millions de dollars australiens (30 millions d'euros), pour encourager la croissance de l'industrie à la fois par les exportations et le tourisme régional.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Fox Creek</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        If you love travel and you love Australian wine, then you have come to the right place. Because Fox Creek’s excellent Shiraz wines take you to the south of Australia in a single sip.
                    </div>

                    <div class="howto-title2">Keeping it in the family</div>
                    <div class="howto-text">
                        A relatively recent winery (yet an old-timer for the Australian wine industry), Fox Creek was established in 1984 by Jim and Helen Watts in McClaren Vale. Hobbyists at first, Jim and Helen spent years developing the black clay soils of their 32-hectare estate, selling the fruit to neighbouring winemakers. However, a daughter graduating from oenology changed all that; the estate’s first vintage, a (now practically unfindable) 1994 Shiraz was an instant success and shot Fox Creek to the top of the fine wine pile. The rest is winemaking history.
                    </div>

                    <div class="howto-title2">Pizzazz in the Shiraz</div>
                    <div class="howto-text">
                        The name Fox Creek is synonymous with Shiraz. The Reserve comes from various high-quality vineyard blocks planted in grey loam and red gravel terroir. The grapes are fermented on their skins for up to 10 days, before they are fermented in stainless steel vats in their state of the art winery. While the Reserve is clearly their flagship wine (and highest scoring  - Robert Parker gave the 1998 96/100), Fox Creek has also had great success with their blends, which include Cabernet Sauvignon, Cabernet Franc, Merlot, Chardonnay, Sauvignon Blanc and Verdelho. Fox Creek sources grapes grown only in the McLaren Vale, most of which come from its own estate vineyards.
                    </div>

                    <div class="howto-title2">Emerging markets mean export markets</div>
                    <div class="howto-text">
                        It is interesting to note that their website is in Chinese as well as English, implying that sales to the east are good, and look set to stay that way. China is the largest importer of Australian wines (followed by Sweden, China, Thailand, Russia and Singapore), a fact no doubt aided by the Australian Government’s “Export and Regional Wine Support Package”, a one-off allocation of $50million AUD (€30million), to encourage growth of the industry through both exports and regional tourism.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FoxCreek",
        data () {
            return {
                select: { report: 'Fox Creek', src: '/wine-guide/australia/mclaren-valley/fox-creek' },
                items: [
                    { report: 'Fox Creek', src: '/wine-guide/australia/mclaren-valley/fox-creek' }
                ]
            }
        },
        methods: {
            changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
        },
        head: {
            title: 'Fox Creek | Vindome Wine Guide',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Savor the rich flavors and unique terroirs of Fox Creek Wines. A premium wine producer in South Australia, Fox Creek is known for its expertly crafted Shiraz, Cabernet Sauvignon, and other varietals that showcase the rich winemaking heritage of the McLaren Vale region. Indulge in the essence of Australia\'s winemaking tradition with every sip from Fox Creek.'
                }
            ],
            bodyAttrs: {
                class: 'wine-guide inner-page'
            }
        }
    }
</script>

<style scoped>
    .container {
        max-width: 1170px;
        padding: 0;
        font-family: 'Poppins', sans-serif;
    }
    .wine-guide-body {
        padding-top: 35px;
    }
    .wine-guide-left {
        width: 300px;
        display: inline-block;
    }
    .wine-guide-right {
        display: inline-block;
        width: calc(100% - 305px);
        vertical-align: top;
    }
    .wine-guide-left-title {
        font-weight: 600;
        color: #024E7B;
        font-size: 18px;
        height: 57px;
        line-height: 57px;
    }
    .wine-guide-country {
        display: block;
        height: 57px;
        line-height: 57px;
        text-decoration: none;
        color: #000;
        font-size: 16px;
        padding-left: 30px;
        width: 260px;
        border-left: 3px solid transparent;
    }
    .wine-guide-country:hover,
    .wine-guide-country.active {
      border-color: #024E7B;
      background: #E5EDF2;
    }
</style>
